export function parseSerialList(text) {
  const tokens = String(text ?? "")
    .split(/[\n,]+|\s+/)
    .map((s) => s.trim())
    .filter(Boolean);
  const serials = [];
  const seen = new Set();
  let duplicateCount = 0;
  for (const token of tokens) {
    if (seen.has(token)) {
      duplicateCount += 1;
      continue;
    }
    seen.add(token);
    serials.push(token);
  }
  return { serials, duplicateCount };
}
